/* tslint:disable */
/* eslint-disable */
import { Injectable } from '@angular/core';
import { HttpClient, HttpResponse } from '@angular/common/http';
import { BaseService } from '../base-service';
import { ApiConfiguration } from '../api-configuration';
import { StrictHttpResponse } from '../strict-http-response';
import { RequestBuilder } from '../request-builder';
import { Observable } from 'rxjs';
import { map, filter } from 'rxjs/operators';

import { DeclaracaoResiduoFontesSeladasCriteriaDto } from '../models/declaracao-residuo-fontes-seladas-criteria-dto';
import { DeclaracaoResiduoFontesSeladasDto } from '../models/declaracao-residuo-fontes-seladas-dto';
import { DeclaracaoResiduoFontesSeladasFormDto } from '../models/declaracao-residuo-fontes-seladas-form-dto';
import { DeclaracaoResiduoFontesSeladasPageDto } from '../models/declaracao-residuo-fontes-seladas-page-dto';


/**
 * Declaração Residuo Radioativo
 */
@Injectable({
  providedIn: 'root',
})
export class DeclaracaoResiduoFontesSeladasService extends BaseService {
  constructor(
    config: ApiConfiguration,
    http: HttpClient
  ) {
    super(config, http);
  }

  /**
   * Path part for operation getDeclaracoesResiduoRadioativo
   */
  static readonly GetDeclaracoesResiduoRadioativoPath = '/declaracao-residuo-fontes-seladas';

  /**
   * Pesquisar Declarações de Residuo Radioativo.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `getDeclaracoesResiduoRadioativo()` instead.
   *
   * This method doesn't expect any request body.
   */
  getDeclaracoesResiduoRadioativo$Response(params?: {
    criteria?: DeclaracaoResiduoFontesSeladasCriteriaDto;
  }): Observable<StrictHttpResponse<DeclaracaoResiduoFontesSeladasPageDto>> {

    const rb = new RequestBuilder(this.rootUrl, DeclaracaoResiduoFontesSeladasService.GetDeclaracoesResiduoRadioativoPath, 'get');
    if (params) {
      rb.query('criteria', params.criteria, {});
    }

    return this.http.request(rb.build({
      responseType: 'json',
      accept: 'application/json'
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<DeclaracaoResiduoFontesSeladasPageDto>;
      })
    );
  }

  /**
   * Pesquisar Declarações de Residuo Radioativo.
   *
   *
   *
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `getDeclaracoesResiduoRadioativo$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  getDeclaracoesResiduoRadioativo(params?: {
    criteria?: DeclaracaoResiduoFontesSeladasCriteriaDto;
  }): Observable<DeclaracaoResiduoFontesSeladasPageDto> {

    return this.getDeclaracoesResiduoRadioativo$Response(params).pipe(
      map((r: StrictHttpResponse<DeclaracaoResiduoFontesSeladasPageDto>) => r.body as DeclaracaoResiduoFontesSeladasPageDto)
    );
  }

  /**
   * Path part for operation submeterDeclaracaoResiduoFontesSeladas
   */
  static readonly SubmeterDeclaracaoResiduoFontesSeladasPath = '/declaracao-residuo-fontes-seladas';

  /**
   * Submeter Declaração Residuo Radioativo.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `submeterDeclaracaoResiduoFontesSeladas()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  submeterDeclaracaoResiduoFontesSeladas$Response(params?: {
    body?: DeclaracaoResiduoFontesSeladasFormDto
  }): Observable<StrictHttpResponse<DeclaracaoResiduoFontesSeladasDto>> {

    const rb = new RequestBuilder(this.rootUrl, DeclaracaoResiduoFontesSeladasService.SubmeterDeclaracaoResiduoFontesSeladasPath, 'post');
    if (params) {
      rb.body(params.body, 'application/json');
    }

    return this.http.request(rb.build({
      responseType: 'json',
      accept: 'application/json'
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<DeclaracaoResiduoFontesSeladasDto>;
      })
    );
  }

  /**
   * Submeter Declaração Residuo Radioativo.
   *
   *
   *
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `submeterDeclaracaoResiduoFontesSeladas$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  submeterDeclaracaoResiduoFontesSeladas(params?: {
    body?: DeclaracaoResiduoFontesSeladasFormDto
  }): Observable<DeclaracaoResiduoFontesSeladasDto> {

    return this.submeterDeclaracaoResiduoFontesSeladas$Response(params).pipe(
      map((r: StrictHttpResponse<DeclaracaoResiduoFontesSeladasDto>) => r.body as DeclaracaoResiduoFontesSeladasDto)
    );
  }

  /**
   * Path part for operation getDeclaracaoResiduoFontesSeladas
   */
  static readonly GetDeclaracaoResiduoFontesSeladasPath = '/declaracao-residuo-fontes-seladas/{id}';

  /**
   * Pesquisar declaração residuo por Id.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `getDeclaracaoResiduoFontesSeladas()` instead.
   *
   * This method doesn't expect any request body.
   */
  getDeclaracaoResiduoFontesSeladas$Response(params: {
    id: number;
  }): Observable<StrictHttpResponse<DeclaracaoResiduoFontesSeladasDto>> {

    const rb = new RequestBuilder(this.rootUrl, DeclaracaoResiduoFontesSeladasService.GetDeclaracaoResiduoFontesSeladasPath, 'get');
    if (params) {
      rb.path('id', params.id, {});
    }

    return this.http.request(rb.build({
      responseType: 'json',
      accept: 'application/json'
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<DeclaracaoResiduoFontesSeladasDto>;
      })
    );
  }

  /**
   * Pesquisar declaração residuo por Id.
   *
   *
   *
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `getDeclaracaoResiduoFontesSeladas$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  getDeclaracaoResiduoFontesSeladas(params: {
    id: number;
  }): Observable<DeclaracaoResiduoFontesSeladasDto> {

    return this.getDeclaracaoResiduoFontesSeladas$Response(params).pipe(
      map((r: StrictHttpResponse<DeclaracaoResiduoFontesSeladasDto>) => r.body as DeclaracaoResiduoFontesSeladasDto)
    );
  }

}
